// Function to update product prices (made globally accessible)
function updateProductPrices() {
    // Helper function to parse price from text
    function parsePrice(priceText) {
            // Remove currency symbols and spaces
            let numericString = priceText.trim().replace(/[^\d.,]/g, '');
            
            // Handle different number formats
            if (numericString.includes(',') && numericString.includes('.')) {
                // Format like 1,234.56 (US format) - comma is thousands separator
                numericString = numericString.replace(/,/g, '');
            } else if (numericString.includes(',') && !numericString.includes('.')) {
                // Check if comma is decimal separator (European format like 1234,56) or thousands separator (like 1,234)
                const parts = numericString.split(',');
                if (parts.length === 2 && parts[1].length <= 2) {
                    // Comma is decimal separator (like 1234,56)
                    numericString = numericString.replace(',', '.');
                } else {
                    // Comma is thousands separator (like 1,234 or 12,345)
                    numericString = numericString.replace(/,/g, '');
                }
            }
            
        return parseFloat(numericString);
    }
    
    // Helper function to calculate and format savings
    function calculateSavings(finalPriceElement, originalPriceElement) {
            let savingsText = '';
            
            if (finalPriceElement && originalPriceElement) {
                const finalPriceValue = parsePrice(finalPriceElement.textContent);
                const originalPriceValue = parsePrice(originalPriceElement.textContent);
                
                // Only calculate savings if we have valid numbers
                if (!isNaN(finalPriceValue) && !isNaN(originalPriceValue)) {
                    const savingsAmount = originalPriceValue - finalPriceValue;
                    
                    // Extract currency symbol from the original price text
                    const priceText = originalPriceElement.textContent.trim();
                    let currencySymbol = '£'; // default
                    
                    // Try to find currency symbol at the beginning
                    const startMatch = priceText.match(/^([^\d\s.,]+)/);
                    if (startMatch) {
                        currencySymbol = startMatch[1];
                    } else {
                        // Try to find currency symbol at the end
                        const endMatch = priceText.match(/([^\d\s.,]+)$/);
                        if (endMatch) {
                            currencySymbol = endMatch[1];
                        }
                    }
                    
                    // Format the savings amount with proper thousands separators
                    const formattedSavings = savingsAmount.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    
                    savingsText = `Save ${currencySymbol}${formattedSavings}`;
            }
        }
        
        return savingsText;
    }
    
    // Helper function to update price elements
    function updatePriceElements(finalPrice, originalPrice, savingsText) {
            // Update all product__price elements with final price (but NOT compare prices)
            const productPriceElements = document.querySelectorAll('.product__price:not(.product__price--compare)');
            productPriceElements.forEach(element => {
                element.textContent = finalPrice;
            });
            
            // Update all product__price--compare elements with original price (both footer and regular compare)
            const productComparePriceElements = document.querySelectorAll('.product__price--compare--footer, .product__price.product__price--compare');
            productComparePriceElements.forEach(element => {
                element.textContent = originalPrice; 
            });
            
            // Update all product__price-savings elements
            const productSavingsElements = document.querySelectorAll('.product__price-savings');
            productSavingsElements.forEach(element => {
            element.textContent = savingsText;
        });
    }
    
    // Check for roll-ons bundle structure
    const selectedPackOption = document.querySelector('.sy-roll-ons-pack-option.sy-roll-ons-selected');
    
    if (selectedPackOption) {
        // Get the final price and original price from the new bundle structure
        const finalPriceElement = selectedPackOption.querySelector('.sy-roll-ons-final-price');
        const originalPriceElement = selectedPackOption.querySelector('.sy-roll-ons-original-price');
        
        if (finalPriceElement && originalPriceElement) {
            const finalPrice = finalPriceElement.textContent.trim();
            const originalPrice = originalPriceElement.textContent.trim();
            const savingsText = calculateSavings(finalPriceElement, originalPriceElement);
            
            updatePriceElements(finalPrice, originalPrice, savingsText);
        }
    } 
    // Check for bundle_block_wrapper structure
    else {
        const selectedBundleWrapper = document.querySelector('.bundle_block_wrapper:has(input.bundle_input_block:checked)');
        
        if (selectedBundleWrapper) {
            // Get the final price and original price from the bundle structure
            const finalPriceElement = selectedBundleWrapper.querySelector('.bundle_normal_price');
            const originalPriceElement = selectedBundleWrapper.querySelector('.bundle_compare_price');
            
            if (finalPriceElement && originalPriceElement) {
                const finalPrice = finalPriceElement.textContent.trim();
                const originalPrice = originalPriceElement.textContent.trim();
                const savingsText = calculateSavings(finalPriceElement, originalPriceElement);
                
                updatePriceElements(finalPrice, originalPrice, savingsText);
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    // Update prices on page load
    updateProductPrices();
    
    // Add event listeners to new bundle pack options using event delegation
    document.addEventListener('click', function(e) {
        if (e.target.closest('.sy-roll-ons-pack-option')) {
            // Use a small delay to ensure the selection state has updated
            setTimeout(updateProductPrices, 50);
        }
    });
    
    // Add event listeners to bundle_block_wrapper selections
    document.addEventListener('change', function(e) {
        if (e.target.classList.contains('bundle_input_block')) {
            // Use a small delay to ensure the selection state has updated
            setTimeout(updateProductPrices, 50);
        }
    });
});
